import Log from '@deephaven/log';
var log = Log.module('redux-crashReporter');
var crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    log.error('Error executing', action, ' with state ', store.getState(), ':', err);
    throw err;
  }
};
export default crashReporter;
//# sourceMappingURL=crashReporter.js.map